export default "__VITE_ASSET__CvRdCrVS__"